import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4b2ca0e9"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "google-tax-manage-content"
};
const _hoisted_2 = {
  class: "filter-wrap"
};
const _hoisted_3 = {
  class: "filter-item"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "filter-item-label"
}, "国家信息：", -1));
const _hoisted_5 = {
  class: "filter-item-input"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "filter-item-label",
  style: {
    "margin-left": "25px"
  }
}, "币种：", -1));
const _hoisted_7 = {
  class: "filter-item-input"
};
const _hoisted_8 = {
  class: "operate-item"
};
const _hoisted_9 = {
  class: "table-wrap"
};
const _hoisted_10 = {
  class: "table-header"
};
const _hoisted_11 = ["onClick"];
import DetailModel from "./DetailModel.vue";
import { useGoogleTaxManage } from "./useGoogleTaxManage";
import AddNewCountryModel from "./AddNewCountryModel.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const {
      filterForm,
      currentTableData,
      columns,
      page,
      addNewCountryModelRef,
      open,
      detailOpen,
      countryInfo,
      detailInfList,
      currentDetailRecord,
      exportLoading,
      handleDetail,
      filterOption,
      handleReset,
      handleSearch,
      handleAddNewCountry,
      handleExport,
      handlePageChange,
      handleShowSizeChange,
      handleCloseModel,
      handleCloseDetailModel
    } = useGoogleTaxManage();
    return (_ctx, _cache) => {
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_table = _resolveComponent("a-table");
      const _directive_no_spaceAline = _resolveDirective("no-spaceAline");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_withDirectives(_createVNode(_component_a_input, {
        value: _unref(filterForm).countryInf,
        "onUpdate:value": _cache[0] || (_cache[0] = $event => _unref(filterForm).countryInf = $event),
        placeholder: "请输入国家/ISO码",
        "allow-clear": ""
      }, null, 8, ["value"]), [[_directive_no_spaceAline]])]), _hoisted_6, _createElementVNode("div", _hoisted_7, [_withDirectives(_createVNode(_component_a_input, {
        value: _unref(filterForm).currency,
        "onUpdate:value": _cache[1] || (_cache[1] = $event => _unref(filterForm).currency = $event),
        placeholder: "请输入货种",
        "allow-clear": ""
      }, null, 8, ["value"]), [[_directive_no_spaceAline]])])]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_a_button, {
        onClick: _unref(handleReset)
      }, {
        default: _withCtx(() => [_createTextVNode("重置")]),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_a_button, {
        type: "primary",
        onClick: _unref(handleSearch)
      }, {
        default: _withCtx(() => [_createTextVNode("搜索")]),
        _: 1
      }, 8, ["onClick"])])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createVNode(_component_a_button, {
        type: "primary",
        onClick: _unref(handleAddNewCountry)
      }, {
        default: _withCtx(() => [_createTextVNode("新增国家")]),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_a_button, {
        onClick: _unref(handleExport),
        loading: _unref(exportLoading)
      }, {
        default: _withCtx(() => [_createTextVNode("导出")]),
        _: 1
      }, 8, ["onClick", "loading"])]), _createVNode(_component_a_table, {
        dataSource: _unref(currentTableData),
        columns: _unref(columns),
        pagination: {
          pageSize: _unref(page).pageSize,
          current: _unref(page).current,
          total: _unref(page).total,
          showTotal: total => `总共 ${total} 条`,
          onChange: _unref(handlePageChange),
          onShowSizeChange: _unref(handleShowSizeChange)
        }
      }, {
        bodyCell: _withCtx(({
          column,
          record
        }) => [column.key === 'id' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createTextVNode(_toDisplayString(record.id), 1)], 64)) : _createCommentVNode("", true), column.key === 'country' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createTextVNode(_toDisplayString(record.country ? record.country : "--"), 1)], 64)) : _createCommentVNode("", true), column.key === 'regionCode' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 2
        }, [_createTextVNode(_toDisplayString(record.regionCode ? record.regionCode : "--"), 1)], 64)) : _createCommentVNode("", true), column.key === 'currency' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 3
        }, [_createTextVNode(_toDisplayString(record.currency ? record.currency : "--"), 1)], 64)) : _createCommentVNode("", true), column.key === 'taxRate' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 4
        }, [_createTextVNode(_toDisplayString(record.taxRate ? `${record.taxRate}%` : "--"), 1)], 64)) : _createCommentVNode("", true), column.key === 'action' ? (_openBlock(), _createElementBlock("span", {
          key: 5,
          style: {
            "cursor": "pointer",
            "color": "#1677ff"
          },
          onClick: $event => _unref(handleDetail)(record)
        }, "详情", 8, _hoisted_11)) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["dataSource", "columns", "pagination"])]), _createVNode(AddNewCountryModel, {
        open: _unref(open),
        ref_key: "addNewCountryModelRef",
        ref: addNewCountryModelRef,
        onHandleCloseModel: _unref(handleCloseModel)
      }, null, 8, ["open", "onHandleCloseModel"]), _createVNode(DetailModel, {
        open: _unref(detailOpen),
        detailInfList: _unref(detailInfList),
        currentDetailRecord: _unref(currentDetailRecord),
        ref: "detailModelRef",
        onHandleCloseModel: _unref(handleCloseDetailModel)
      }, null, 8, ["open", "detailInfList", "currentDetailRecord", "onHandleCloseModel"])]);
    };
  }
});